export enum InputState {
  IDLE = 'idle',
  ACTIVE = 'active',
  WARNING = 'warning',
}
